import { Document as RichTextDocument } from '@contentful/rich-text-types';
import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { z } from 'zod';

import Button from '@/components/BaseLibrary/Button/Button';
import FormInput, {
  InputType,
} from '@/components/BaseLibrary/FormInput/FormInput';
import useStyles from '@/components/InteractiveQuoteForm/InteractiveQuoteForm.styles';
import RichText from '@/components/RichText/RichText';
import useGlobalStyles from '@/styles/global.styles';
import { trackEvents } from '@/utils/analytics';
import {
  InputName,
  phoneValidator,
  referredValidator,
} from '@/utils/validation/inputs';

export interface PhoneStepProps {
  handleNext: (data: SchemaType) => void;
  networkError?: string;
  tcpa: RichTextDocument;
}

const schema = z.object({
  ...phoneValidator,
  ...referredValidator,
});
type SchemaType = z.infer<typeof schema>;

export default function ZipCodeStep({
  handleNext,
  networkError,
  tcpa,
}: PhoneStepProps) {
  const { classes } = useStyles();
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });
  const [wasReferred, setWasReferred] = useState<boolean>(false);
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<SchemaType>({
    resolver: zodResolver(schema),
    mode: 'onTouched',
    defaultValues: {
      [InputName.REFERRED]: false,
    },
  });

  const onSubmit: SubmitHandler<SchemaType> = (data: SchemaType) => {
    trackEvents({
      event: 'Form_cta_click',
      Form_tab: 'Zip Code',
      Form_step: 1,
      click_text: 'Next',
    });
    handleNext(data);
  };

  return (
    <>
      <FormInput
        label='Phone'
        testId='phone-input'
        type={InputType.TEL}
        inputMode='tel'
        error={errors[InputName.PHONE]?.message}
        name={InputName.PHONE}
        register={register}
      />
      <div className={classes.checkboxContainer}>
        <input
          type='checkbox'
          id='referredCheckbox'
          checked={wasReferred}
          onChange={() => setWasReferred(!wasReferred)}
          className={classes.checkbox}
        />
        <label htmlFor='referredCheckbox' className={globalClasses.body}>
          I was referred to Sunrun by a friend or family member
        </label>
      </div>
      <label>
        <input
          type='hidden'
          id='leadid_tcpa_disclosure'
          name='Terms of Service'
        />
        <RichText title='' content={tcpa} />
      </label>
      <div style={{ marginTop: 15 }}>
        <Button
          onClick={handleSubmit(onSubmit)}
          label='Submit'
          disabled={!isValid}
          className={classes.button}
        />
        {networkError && <p className={classes.error}>{networkError}</p>}
      </div>
    </>
  );
}
